import { useContext } from "react";
import { ChatSupportContext } from "../contexts";

export function useChatSupport() {
  const context = useContext(ChatSupportContext);
  if (!context) {
    // safe error handling for tenant apps that haven't wrapped their app in the ChatSupportProvider yet
    console.error(
      "ChatSupportProvider is missing in the DOM tree for this travel portal."
    );

    return {};
  }
  return context;
}
